import { Link } from "@StarberryUtils";
import PropTypes from "prop-types";
import React from "react";
import {Col, Row, Container } from 'react-bootstrap';
import  "../Intro/Intro.scss";
//import "animate.css/animate.min.css";
import VideoPlay from "../../Play/news-video-with-background";
import ReactMarkdown from "react-markdown"
import Breadcrumbs from "../../MgServices/Breadcrumb/news-breadcrumb"

import { NewsDate, GetURL } from "../../common/site/functions";
import SocialShare from "../../utils/socialShare";

const NewsStaticPage = (props, { siteTitle }) => {

  const [Shareicons,setShareicons] = React.useState(false);
  const openShareicons = () => {
    setShareicons(true);
    if(Shareicons === true) {
      setShareicons(false);
    }
  }

  let url = '/'
  if(props.Right_Side_Block_CTA_Link) {
    url = GetURL(props.Right_Side_Block_CTA_Link.id)
  }
  
return(
  <section className="managing-sec managing-intro static-news-page static-content-two">
    <div className="rental-market">
      <Container>
        <Row>
          <Col className="static-details-top-head" xl={8}>
          <Breadcrumbs url={props.url} tag="details" Title={props.Title} category={props.category}/>
          <h1>{props.Title}</h1>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col className="order-2 order-xl-1" xl={8}>
            <div className="rental-post news-content">
              {props.Content.map((content, i) => {  
                  return <>
                    {content.Content !== null &&
                      <ReactMarkdown source={content.Content ? content.Content : ''} allowDangerousHtml className="editor"/>
                    }

                    {content.Background_Image ?
                      <VideoPlay image={content.Background_Image.url} url_1={content.Embed_Video_URL} url_2={content.Upload_Video} title={props.Title}/> : ''
                    }
                  </>
              })}

            </div>
          </Col>
          <Col className="order-1 order-xl-2" xl={4}>
          <div className="news-details-static-sidebar">
            <ul className="detail-list">
              {props.Date ? <li><strong className="highlited">Date Posted</strong><span className="desc news-date">{NewsDate(props.Date)}</span></li> : '' }

              {props.Category ? <li><strong className="highlited">Category</strong><span className="desc">{props.Category[0].Name}</span></li> : '' }

              {props.Author ? <li><strong className="highlited">Author</strong><span className="desc">{props.Author}</span></li> : '' }

              <li>
              <a className="desc news-details-social-share" onClick={openShareicons} role="presentation">
                <i className="icon-share"></i>Share
                {Shareicons &&
                  <SocialShare openShareicons={openShareicons} role={"presentation"} />
                }
              </a>
              {props.Upload_File ? <span className="desc">
              <a href={props.Upload_File.url} target="_blank" rel="noreferrer"><i className="icon-print"></i>Print</a>
              </span> : '' }
              </li>
            </ul>

            {props.Right_Side_Block_Title != null || props.Speak_with != null ? 
            <div className="get-quote d-none d-xl-block">
              {props.Right_Side_Block_Title ? <h3 className="get-title">{props.Right_Side_Block_Title}</h3> : '' }
              {props.Right_Side_Block_CTA_Label ? <Link to={`/${url}`} class="btn">{props.Right_Side_Block_CTA_Label}</Link> : '' }
              {props.Speak_with ?
              <>
              <p className="get-desc">We’re here to help – just follow the link below to get in touch.<br/> <Link to={`/about/our-people/${props.Speak_with?.URL}`}>{props.Speak_with.Name}</Link></p>

              <div className="get-profile d-flex align-items-center">
                <figure><img loading="lazy" src={`${props.Speak_with.Tile_Image.url}`} alt="profile-img" /></figure>
                <div className="prof-info">
                  <span className="name">{props.Speak_with.Name}</span>
                  <a href={`tel:${props.Speak_with.Phone}`}>{props.Speak_with.Phone}</a>
                </div>
              </div></> : '' }

            </div> : '' }
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </section>
)
}

NewsStaticPage.propTypes = {
  siteTitle: PropTypes.string,
}

NewsStaticPage.defaultProps = {
  siteTitle: ``,
}

export default NewsStaticPage
